'use client';

import React, { useEffect } from 'react';

/**
 * INSTRUMENTACAO TEMPORARIA - remover apos identificar o erro em producao.
 * Captura erros fatais que ocorrem no nivel do layout raiz (incluindo hydration crash).
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[global-error.tsx] ===== GLOBAL ERROR BOUNDARY =====');
    console.error('[global-error.tsx] message   :', error.message);
    console.error('[global-error.tsx] digest    :', error.digest);
    console.error('[global-error.tsx] stack     :', error.stack);
    console.error('[global-error.tsx] name      :', error.name);
    console.error('[global-error.tsx] error obj :', error);
    console.error('[global-error.tsx] ================================');
  }, [error]);

  return (
    <html lang="pt-BR">
      <body style={{ fontFamily: 'sans-serif', padding: '2rem', textAlign: 'center' }}>
        <p style={{ color: '#666', fontSize: '0.875rem' }}>
          Ocorreu um erro critico. Por favor, recarregue a pagina.
        </p>
        <button
          onClick={reset}
          style={{ marginTop: '1rem', padding: '0.5rem 1rem', cursor: 'pointer' }}
        >
          Tentar novamente
        </button>
      </body>
    </html>
  );
}
